import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="container">
        <h1>About Roll Forming Machine & Die Manufacturing</h1>
        
        <div className="about-content">
          <section className="company-history">
            <h2>Our History</h2>
            <p>
              Founded in 1956, Roll Forming Machine & Die Manufacturing Co. Ltd. has become a recognized 
              leader in the manufacture of roll forming machines and equipment. Our excellent reputation 
              for sound and innovative engineering has been built through our experience serving customers 
              with the ultimate in efficiency for roll forming tooling and equipment.
            </p>
          </section>

          <section className="technology">
            <h2>Technology & Innovation</h2>
            <p>
              The use of our latest 3D CAD CAM technology ensures the highest standards of tooling and 
              machine parts. Our company has produced equipment and tooling for all types of industries, 
              with thickness ranging from .003" to .500" and high strength 100% steel. Tool proving 
              service is available in-house and on-site when required.
            </p>
          </section>

          <section className="capabilities">
            <h2>Our Capabilities</h2>
            <div className="capability-grid">
              <div className="capability-item">
                <h3>Material Range</h3>
                <p>Thickness from .003" to .500"</p>
              </div>
              <div className="capability-item">
                <h3>Material Strength</h3>
                <p>Up to 190K yield strength</p>
              </div>
              <div className="capability-item">
                <h3>Industries Served</h3>
                <p>Automotive, Construction, Electronics, Transportation, and more</p>
              </div>
              <div className="capability-item">
                <h3>Equipment Types</h3>
                <p>Standard formers, panel machines, custom equipment</p>
              </div>
            </div>
          </section>

          <section className="commitment">
            <h2>Our Commitment</h2>
            <p>
              Whether you are looking for a high quality, low cost producer, or engineering support 
              to help solve your most critical design problems, Roll Forming Machine & Die has the 
              solution. We insure consistent on-time delivery of quality roll formers and tooling 
              on the customer's budget. We have a variety of standard models available in different 
              designs and sizes, or we can custom make for you.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;